// extracted by mini-css-extract-plugin
export default {"poopUp":"poopUp_poopUp__-i2Dq","appearance":"poopUp_appearance__PdNj8","window":"poopUp_window__r0cGu"};